// Stub for @aws-amplify/ui-components — Kinde handles auth, Cognito not used.
var Translations = {
  TOTP_ISSUER: 'TOTP_ISSUER',
  CONFIRM_TOTP_CODE: 'CONFIRM_TOTP_CODE',
  TOTP_HEADER_TEXT: 'TOTP_HEADER_TEXT',
  SIGN_IN_TEXT: 'SIGN_IN_TEXT',
  SIGN_IN_ACTION: 'SIGN_IN_ACTION',
  SIGN_UP_TEXT: 'SIGN_UP_TEXT',
  SIGN_OUT: 'SIGN_OUT',
  BACK_TO_SIGN_IN: 'BACK_TO_SIGN_IN',
  USERNAME_LABEL: 'USERNAME_LABEL',
  PASSWORD_LABEL: 'PASSWORD_LABEL',
  EMAIL_LABEL: 'EMAIL_LABEL'
}

function onAuthUIStateChange(callback) {
  // Returns an unsubscribe function
  return function() {}
}

function applyPolyfills() {
  return Promise.resolve()
}

function defineCustomElements() {
  return Promise.resolve()
}

module.exports = {
  Translations: Translations,
  onAuthUIStateChange: onAuthUIStateChange,
  applyPolyfills: applyPolyfills,
  defineCustomElements: defineCustomElements
}
